// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailsEnergyAssetsSettlementsRules_wrapper__GnbsX","col":"DetailsEnergyAssetsSettlementsRules_col__fkzT1"};